var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 2.33333H0V10.5C0 11.1417 0.525 11.6667 1.16667 11.6667H9.33333V10.5H1.16667V2.33333ZM10.5 0H3.5C2.85833 0 2.33333 0.525 2.33333 1.16667V8.16667C2.33333 8.80833 2.85833 9.33333 3.5 9.33333H10.5C11.1417 9.33333 11.6667 8.80833 11.6667 8.16667V1.16667C11.6667 0.525 11.1417 0 10.5 0ZM10.5 8.16667H3.5V1.16667H10.5V8.16667ZM4.66667 4.08333H9.33333V5.25H4.66667V4.08333ZM4.66667 5.83333H7V7H4.66667V5.83333ZM4.66667 2.33333H9.33333V3.5H4.66667V2.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkOrderIcon);
export default __webpack_public_path__ + "static/media/BulkOrderIcon.7c069405c99e839e308c8585f0a92ed3.svg";
export { ForwardRef as ReactComponent };